import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  surchargeTitle: {
    defaultMessage:
      'A {percentage}% Credit Card Processing Fee applies when funding your balance, including auto-funding, with a credit card.',
    description: 'Title message explaining the credit card surcharge fee',
    id: 'LTaacy',
  },
  surchargeSubtitle: {
    defaultMessage: 'Avoid this fee by updating your ShipStation balance payment method below to a bank account.',
    description: 'Subtitle message explaining how to avoid the surcharge fee',
    id: 'JhPVLe',
  },
  connectBankAccount: {
    defaultMessage: 'Connect bank account',
    description: 'Button text to connect a bank account',
    id: 'fJjxra',
  },
  totalChargeLabel: {
    defaultMessage: '<b>Total Charge</b>',
    description: 'Label for the total charge amount including surcharge',
    id: 'QIZdlf',
  },
  fundsLabel: {
    defaultMessage: 'Funds',
    description: 'Label for the base amount of funds to add before surcharge',
    id: 'upCsUI',
  },
  surchargeLabel: {
    defaultMessage: 'Credit Card Processing Fee ({creditCardProcessingFeePercentage}%)',
    description: 'Label for the credit card processing fee with creditCardProcessingFeePercentage',
    id: 'KMEhpD',
  },
  pleaseRetry: {
    defaultMessage: 'Something went wrong calculating your total, please retry or contact support.',
    description: 'Message prompting the user to retry after an error',
    id: 'MnDJap',
  },
  retry: {
    defaultMessage: 'Retry',
    description: 'Button text to retry after an error',
    id: 'evC2Kk',
  },
  fallbackErrorMessage: {
    id: 'hlvuO7',
    defaultMessage: 'Something went wrong calculating your total, please retry or contact support.',
    description: 'Generic error message shown when fee calculation fails',
  },
});
